import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import { postData } from "../../services/Services";
import Button from "../atomic/Button/Button";
import InputText from "../atomic/Input/InputText";
import CustomModal from "../atomic/Modal/CustomModal";
import { css } from "@emotion/react";
import styles from "./LoginPhone.module.css";
import { useDispatch, useSelector } from "react-redux";
import { setPhone } from "../../redux/action/otpAction";
import { REGEX } from "../../constant/regexConst";

const LoginPhone = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [formData, setFormData] = useState({
    phone: "",
  });

  const request_id = searchParams.get("request_id");
  const redirect_uri = searchParams.get("redirect_uri");
  const resource_id = searchParams.get("resource_id");
  const isRegister = searchParams.get("isRegister");
  const cancel_uri = searchParams.get("cancel");
  const twofa_type = searchParams.get("2fa_type");

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");

  // Redux State
  const dispatch = useDispatch();
  const isValidated = useSelector(
    (state) => state.validateData.data.isValidated
  );
  const verifiedPhone = useSelector((state) => state.otpData.phone);

  const checkErrorValidation = () => {
    if (formData.phone.length === 0) {
      return true;
    }
    if (!REGEX.PHONE_NUBMER.test(formData.phone)) {
      return true;
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (checkErrorValidation()) {
      return;
    }
    handleVerificationPhoneNumber();
  };

  const handleVerificationPhoneNumber = async () => {
    setLoading(true);
    const body = {
      phone_number: formData.phone,
    };
    postData("/v3/auth/login/pwa/checkphonenumber", token, body)
      .then((response) => {
        setLoading(false);
        if (response?.data?.status === 1) {
          dispatch(setPhone(formData.phone));
          navigate(
            `/send-method?token=${token}&request_id=${request_id}&redirect_uri=${redirect_uri}&resource_id=${resource_id}&isRegister=${isRegister}&cancel=${cancel_uri}&2fa_type=${
              twofa_type ? twofa_type : ""
            }&isNextPage=true`
          );
        } else if (response?.data?.status === 400) {
          setOpen(true);
          setMessage(
            response?.data?.data?.message ||
              "Nomor ponsel tidak terdaftar, silahkan coba lagi"
          );
          setTitle("Gagal");
        } else {
          setOpen(true);
          setMessage("Terjadi kesalahan, silahkan coba lagi");
          setTitle("Gagal");
        }
      })
      .catch((error) => {
        setLoading(false);
        setOpen(true);
        setMessage("Terjadi kesalahan, silahkan coba lagi");
        setTitle("Gagal");
      });
  };

  const handleChange = (e) => {
    if (e.target.name === "phone") {
      if (/^[0-9+]*$/.test(e.target.value)) {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value,
        });
      }
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  useEffect(() => {
    if (verifiedPhone) {
      setFormData({
        ...formData,
        phone: verifiedPhone,
      });
    }
  }, []);

  return (
    <div className={styles.loginContainer}>
      {loading && (
        <Box
          position={"absolute"}
          width="100vw"
          top="0"
          left="0"
          height="100vh"
          zIndex="9999999999"
          display="flex"
          alignItems="center"
          justifyContent={"center"}
        >
          <Box
            position={"absolute"}
            width="100vw"
            top="0"
            left="0"
            sx={{ background: "black", opacity: "10%" }}
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent={"center"}
          ></Box>
          <PuffLoader css={css} color={"black"} loading={loading} size={150} />
        </Box>
      )}
      <Box width="80%" sx={{ height: "100vh" }}>
        {!isValidated && <div>Akses Tidak Diijinkan</div>}
        {isValidated && (
          <Box height={"100%"}>
            <form
              onSubmit={handleSubmit}
              style={{
                width: "100%",
                height: "100%",
                paddingBlock: "20px 0px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "10px",
              }}
            >
              <InputText
                type={"text"}
                name={"phone"}
                label={"Nomor Ponsel"}
                placeholder={"Masukkan nomor ponsel yang terdaftar"}
                onChange={handleChange}
                width={`100%`}
                value={formData.phone}
                length={
                  formData.phone.charAt(0) === "0"
                    ? 13
                    : formData.phone.charAt(0) === "+"
                    ? 15
                    : 14
                }
              />
              <Box
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                }}
              >
                {formData.phone.length !== 0 &&
                  !REGEX.PHONE_NUBMER.test(formData.phone) && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "12px",
                        fontStyle: "italic",
                      }}
                    >
                      *Nomor ponsel tidak sesuai format
                    </span>
                  )}
              </Box>
              <br />
              <br />
              <br />
              <Typography fontWeight={500} fontSize={12} textAlign={"justify"} color={"#818181"}>
                Klik lanjut maka kode OTP akan dikirim melalui SMS atau Whatsapp
                ke nomor ponsel yang dimasukkan
              </Typography>

              <Button
                disabled={
                  formData.phone.length === 0 ||
                  !REGEX.PHONE_NUBMER.test(formData.phone)
                }
                value={"Lanjut"}
                width={"100%"}
                height={"45px"}
                background={"#D81922"}
                color={"white"}
              />
            </form>
          </Box>
        )}

        <CustomModal
          open={open}
          onClose={() => setOpen(false)}
          variant={"error"}
          text={message}
          title={title}
        />
      </Box>
    </div>
  );
};

export default LoginPhone;
